<template>
  <div class="main-logo">
    <div class="logo-container">
      <img src="@/assets/small-logo.png" alt="logo" width="131" height="132" />

    </div>
    <div class="text" :class="{ minimized }">
      <img src="@/assets/logo-text.png" alt="logo-text" width="1598" height="431">
    </div>
  </div>

</template>

<script>
export default {
  props: {
    minimized: {
      required: false,
      default: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.main-logo {
  transition: padding .3s ease;
  direction: ltr;
  display: flex;
  flex-direction: row;
  align-items: center;

  overflow: hidden;
}
.logo-container {
  min-width: 60px;
  height: 60px;
  transition: transform .3s ease;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  img {
    height: auto;
    transition: transform .5s ease;
    width: 50px;
    &:hover {
      transform: rotate(360deg);
    }
  }
}
.text {
  height: 60px;
  padding-left: 10px;

  display: flex;
  flex-direction: row;
  align-items: center;
  transition: margin-left 0.3s ease, opacity 0.3s ease;

  img {
    width: 130px;
    height: auto;
  }

  &.minimized {
    margin-left: 50px;
    opacity: 0;
  }
}

</style>
